/** The four words for what a figure rests on, and the one-line reading of each - P15 item 3.
 *
 * Their own module so `BasisChip.tsx` exports only a component (fast refresh), and so a screen that
 * needs the words but not the chip can have them. The word itself is the server's
 * (`inventory/basis.py`); nothing here decides one.
 */

export const BASES = ["metered", "estimate", "supplier_stated", "imported_no_document"] as const;
export type Basis = (typeof BASES)[number];

export function isBasis(value: string | undefined | null): value is Basis {
  return typeof value === "string" && (BASES as readonly string[]).includes(value);
}

export const BASIS_WORD: Readonly<Record<Basis, string>> = {
  metered: "Metered",
  estimate: "Estimate",
  supplier_stated: "Supplier-stated basis",
  imported_no_document: "Imported, no document",
};

/** One line each. The grades' own definitions (`scope1.grades`) are the source of the first two. */
export const BASIS_TIP: Readonly<Record<Basis, string>> = {
  metered: "Grade A: a reading EmitIQ can trace to a bill it holds.",
  estimate: "Graded below A: recorded by a person, split from a larger figure, or estimated.",
  supplier_stated: "Rests on a supplier's own statement of how the figure was reached.",
  imported_no_document: "Arrived through an import and cites no bill.",
};
